/**
 * Como chamar o material de um serviço já pedido.
 *
 * O rótulo congelado vem primeiro. O laboratório pode renomear ou desativar a oferta a qualquer
 * momento — e quando faz isso, o pedido tem que continuar dizendo o que foi pedido, não o nome
 * novo. `materialLine` é o fallback do modo laboratório antigo, que ainda aparece em histórico.
 */
export function rotuloDoMaterialDoServico(
  servico:
    | {
        materialOptionLabel?: string | null;
        materialOption?: { label: string } | null;
        materialLine?: { name: string } | null;
      }
    | null
    | undefined,
): string | null {
  return (
    servico?.materialOptionLabel ?? servico?.materialOption?.label ?? servico?.materialLine?.name ?? null
  );
}
